<body>

    <login></login>

    <div class="container body-content on-light">

        <shared-header [appLocation]="thisRoute">
            <div>
                <div [ngSwitch]="thisRoute">
                    <div>
                        <h3>Configure</h3>
                        <a [routerLink]="['/templates']">Templates</a>
                        <a [routerLink]="['/themes']">Themes</a>
                        <a [routerLink]="['/modules']">Modules</a>
                    </div>
                </div>
            </div>
        </shared-header>

        <router-outlet></router-outlet>

    </div>

    <footer>&copy; 2023 - Dunstan Thomas Holdings Ltd.</footer>

    <dialog-overlay></dialog-overlay>
    <shared-error-overlay></shared-error-overlay>

</body>
